import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Title from '../patient/generics/Title';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {pencil} from 'react-icons-kit/icomoon/pencil';
import {bin} from 'react-icons-kit/icomoon/bin';
import Help from '../generics/help';

var Config = require('../../config');

class Supplies extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.newRegister = this.newRegister.bind(this);
		this.onEdit = this.onEdit.bind(this);

		this.state = {
			filter: "",
			list:[],
		}
	}

	componentDidMount(){
		this.reload();
	}

	reload(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_reagents', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({list: response});
			}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.name !== null &&
				row.code !== null &&
				row.barcode !== null &&
				row.presentation !== null
			){
				if(
					row.name.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.code.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.barcode.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.presentation.indexOf(this.state.filter.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	newRegister(){
		this.props.history.push('/supplies_reagents/new');
	}

	onEdit(id){
		this.props.history.push('/supplies_reagents/edit/'+id);
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	fetch(Config.default.apiGateway.URL+'supplies_reagents?id='+id,{ 
		            method: 'delete',

		            headers: new Headers({
		               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		               'Accept': 'application/json',
		              'Content-Type': 'application/json',
		            })
	          	}).then(res => {
		            if(res.ok){
		              	return res.json();
		            }else{
		              	res.text().then(function(result) {
		                	swal('¡Error!', result, 'error');
		              	});
		            }
		        }).then(res => {
	              	if(res !== undefined){
	                	swal('Buen Trabajo', 'Registro Eliminado','success');
	                	this.reload();
	              	}
	          	})
	        }
	    }.bind(this));
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
                        {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Insumos
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_supplies_reagentss"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

					<div className="col-xs-12 col-sm-1 col-sm-offset-9">
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							onClick={this.newRegister}
							disabled={!this.props.supplies.create}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Nombre</th>
								<th>Codigo</th>
								<th>Codigo de Barras</th>
								<th>Presentación</th>
								<th>Unidades</th>
								<th>Costo</th>
								<th>Mínimo</th>
								<th>Máximo</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((list, i)=>{
								return  this.filter(list) ?
									<tr key={i} >
										<td>{list.name}</td>
										<td>{list.code}</td>
										<td>{list.barcode}</td>
										<td>{list.presentation}</td>
										<td>{list.units}</td>
										<td>{list.cost_unit}</td>
										<td>{list.min}</td>
										<td>{list.max}</td>
										<td>
											<button type="button" className="btn btn-info btn-xs"
												onClick={this.onEdit.bind(this, list.id)}
												disabled={!this.props.supplies.update}
												style={{margin:"0 5px"}}>
												<SvgIcon icon={pencil}/>
											</button>

											<button type="button" className="btn btn-info btn-xs"
												onClick={this.onDelete.bind(this, list.id)}
												disabled={!this.props.supplies.delete}
												style={{margin:"0 5px"}}>
												<SvgIcon icon={bin}/>
											</button>
										</td>
									</tr>
								: null
							})}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}
}

export default translate('translations') (Supplies);